/**
 * The one style the ownership lock overrides.
 *
 * Locked controls carry the app-wide `non-clickable` class (`common.css` —
 * `pointer-events: none; opacity: .5`), which is what the legacy forms use for
 * a read-only field. The pointer-events half is the point of the class here;
 * the fade is not wanted — with 28 of 30 rail rows locked for a `network` user,
 * a greyed rail reads as broken rather than as read-only.
 *
 * ★ WHY INLINE AND NOT A STYLESHEET RULE. `/static/` is served from the shared
 * tree, not from a branch's worktree, so an edit to `css/partners/styles.css`
 * is invisible in a preview environment — the fix would look unapplied to
 * whoever is testing it. An inline style ships with the bundle and beats the
 * class either way (`.non-clickable` sets no `!important`).
 */
export const NON_CLICKABLE_OPAQUE = { opacity: 1 } as const;
